export const FETCH_UPCOMINGS = 'FETCH_UPCOMINGS'
export const FETCH_UPCOMINGS_REQUEST = 'FETCH_UPCOMINGS_REQUEST'
export const FETCH_UPCOMINGS_SUCCESS = 'FETCH_UPCOMINGS_SUCCESS'